import { buildDomainSeoBundle } from "./agenticSeoUtils";

export const TELECOM_DOMAIN_INTRO = {
  title: "Telecom",
  content: "Agentic AI workflow automation for Telecom — across Mobile Network, Telecom Customer Care, Field Operations, Network Operations, and B2B Telecom. Use cases span network alarm triage, customer complaint classification, technician dispatch optimization, incident postmortem summaries, and enterprise quote-to-order automation. Practical deployments for telecom operators in India, UAE, KSA, UK, and USA with human-in-the-loop review, status tracking, and audit evidence.",
  seoDescription: "Telecom agentic AI use cases — mobile network, customer care, field operations, network operations, B2B telecom. Network alarm triage, complaint classification, technician dispatch, incident postmortem, enterprise quote to order. BSS OSS CRM ITSM integration.",
};

const slug = (label) => label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

function withMeta(uc) { return { ...uc, groupId: slug(uc.subIndustry), seoTitle: uc.title, title: uc.shortTitle || uc.title }; }

const TELECOM_SYSTEMS = "BSS/OSS, CRM, Network Monitoring, ITSM, Email, Power BI";

const RAW = [
  {
    id: "network-alarm-triage",
    subIndustry: "Mobile Network",
    department: "Network Operations",
    businessProcess: "Network alarm triage",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "Network alarm triage",
    title: "Network Alarm Triage Automation for Telecom",
    seoKeywords: "telecom, network alarm triage, AI automation, RPA, agentic AI",
    challenge: "NOC teams manually review large volumes of alarms and correlate them with incidents.",
    solution: "Implement Agentic AI + Data Automation to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    summary: "Mobile Network teams can improve network alarm triage with agentic AI workflow automation that captures inputs, validates rules, routes exceptions, and updates business systems with human approval where needed — reducing manual effort and improving audit trails.",
    automationType: "Agentic AI + Data Automation",
    buyerPersona: "CTO, Network Operations Head",
    systems: TELECOM_SYSTEMS,
    agentsRequired: "Data Collection Agent, Network Insight Agent, Alert Agent",
    inputData: "System exports, transaction records, logs, historical data, master data and network alarm triage business rules",
    outputActions: "Dashboard, anomaly alerts, forecast or action list for network alarm triage",
    keyBenefits: "Faster Turnaround, Lower Manual Effort, Improved Accuracy And Better Operational Visibility",
    roiTimeline: "12+ months",
    implementationComplexity: "High",
    businessImpact: "High",
  },
  {
    id: "incident-postmortem-summary",
    subIndustry: "Network Operations",
    department: "Incident Management",
    businessProcess: "Incident postmortem summary",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "Incident postmortem summary",
    title: "Incident Postmortem Summary Automation for Telecom",
    seoKeywords: "telecom, incident postmortem summary, AI automation, RPA, agentic AI, document AI",
    challenge: "Teams manually compile alarms, actions, timelines and root cause notes after major incidents.",
    solution: "Implement Agentic AI + Document AI to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    summary: "Network Operations teams can improve incident postmortem summary with agentic AI workflow automation that captures inputs, validates rules, routes exceptions, and updates business systems with human approval where needed — reducing manual effort and improving audit trails.",
    automationType: "Agentic AI + Document AI",
    buyerPersona: "NOC Head, CIO",
    systems: TELECOM_SYSTEMS,
    agentsRequired: "Document Extraction Agent, Incident Validation Agent, Exception Agent",
    inputData: "Forms, PDFs, emails, scanned documents, attachments, master data and incident postmortem summary rules",
    outputActions: "Extracted structured data, validation results, exception list and approval-ready incident postmortem summary record",
    keyBenefits: "Faster Turnaround, Lower Manual Effort, Improved Accuracy And Better Operational Visibility",
    roiTimeline: "6-12 months",
    implementationComplexity: "High",
    businessImpact: "Medium",
  },
  {
    id: "enterprise-quote-to-order-automation",
    subIndustry: "B2B Telecom",
    department: "Sales Operations",
    businessProcess: "Enterprise quote to order automation",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "Enterprise quote to order automation",
    title: "Enterprise Quote To Order Automation Automation for Telecom",
    seoKeywords: "telecom, enterprise quote to order automation, AI automation, RPA, agentic AI",
    challenge: "B2B quotes, approvals and order forms are manually prepared and validated.",
    solution: "Implement Agentic AI + RPA to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    summary: "B2B Telecom teams can improve enterprise quote to order automation with agentic AI workflow automation that captures inputs, validates rules, routes exceptions, and updates business systems with human approval where needed — reducing manual effort and improving audit trails.",
    automationType: "Agentic AI + RPA",
    buyerPersona: "Enterprise Sales Head, COO",
    systems: TELECOM_SYSTEMS,
    agentsRequired: "RPA Posting Agent, Enterprise Validation Agent, Exception Agent",
    inputData: "Emails, forms, system records, task notes, master data and enterprise quote to order automation process rules",
    outputActions: "Validated workflow record, task assignment, status update and exception report for enterprise quote to order automation",
    keyBenefits: "Faster Turnaround, Lower Manual Effort, Improved Accuracy And Better Operational Visibility",
    roiTimeline: "6-12 months",
    implementationComplexity: "High",
    businessImpact: "High",
  },
];
export const TELECOM_USE_CASES = RAW.map(withMeta);
const GROUP_ORDER = ["Mobile Network", "Network Operations", "B2B Telecom"];
export const TELECOM_GROUPS = GROUP_ORDER.map((label) => ({ id: slug(label), label })).filter((g) => TELECOM_USE_CASES.some((uc) => uc.groupId === g.id));
const seo = buildDomainSeoBundle({ domainSlug: 'telecom-domain', domainIntro: TELECOM_DOMAIN_INTRO, useCases: TELECOM_USE_CASES });
export const TELECOM_USE_CASES_SEO = seo.useCasesSeo;
export const TELECOM_DOMAIN_FAQS = seo.domainFaqs;
export const TELECOM_ITEM_LIST_JSONLD = seo.itemListJsonLd;
export const TELECOM_FAQ_JSONLD = seo.faqJsonLd;
export const TELECOM_BREADCRUMB_JSONLD = seo.breadcrumbJsonLd;
export const TELECOM_WEBPAGE_JSONLD = seo.webPageJsonLd;

